import React from 'react';
import { closeCircle } from 'ionicons/icons';
import { IonModal, IonButton, IonIcon } from '@ionic/react';
import '../../styles/settingsModal/DeleteAccountModal.scss';

const DeleteAccountModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose} className='delete-account-modal transparent-modal' backdropDismiss>
      <div className='delete-account-content'>
        <div className='delete-account-header'>
          <IonButton fill='clear' className='close-btn' />
          <h2>We&apos;re sad to see you go...</h2>
          <IonButton fill='clear' className='close-btn' onClick={onClose}>
            <IonIcon icon={closeCircle} />
          </IonButton>
        </div>
        <div className='delete-account-main'>
          <p>
            Are you sure you want to delete this account? All data will be permanently lost and cannot be recovered
            later.
          </p>
          <IonButton className='keep-btn' expand='block' onClick={onClose}>
            Keep FoodFighting
          </IonButton>
          <IonButton className='confirm-delete-btn' expand='block' onClick={onConfirm}>
            Delete Account
          </IonButton>
        </div>
      </div>
    </IonModal>
  );
};

export default DeleteAccountModal;
